"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dependencyTypes = void 0;
/** Dependencies object attributes (type of dependency) */
exports.dependencyTypes = ['mapper', 'validator', 'repository', 'useCase', 'controller'];
//# sourceMappingURL=types.js.map